import { render, staticRenderFns } from "./IconSvgBriefCase.vue?vue&type=template&id=c433ac8c&scoped=true&"
import script from "./IconSvgBriefCase.vue?vue&type=script&lang=js&"
export * from "./IconSvgBriefCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c433ac8c",
  null
  
)

export default component.exports